<template>
    <div class="action-schedule">
        <div class="message m-b-8">
            <div class="message-top">
                <img :src="require('@/assets/images/icon-hand.png')" alt="" />
                <span v-html="introduction.title" />
            </div>
            <div class="message-content">
                <div class="desc" v-html="introduction.desc" />
                <div class="desc-detail">
                    *유의사항*<br />약속을 확정하지 않으면 만남 의사가 없는 것으로 간주하고 약속이 자동 취소처리되며,
                    미진행 수수료 2만원이 부과됩니다.
                </div>
                <div class="grey-box">
                    <div class="user-profile">
                        <img :src="photoUrl" alt="" />
                        <div class="profile-info">
                            <div class="age" v-html="age" />
                            <div class="region" v-html="content.region" />
                            <div class="job" v-html="content.job" />
                        </div>
                    </div>
                </div>
                <div v-if="gender === 1" class="grey-box m-t-8">
                    <div class="title-grey">약속 내용</div>
                    <!--   하드코딩  -->
                    <div class="content-grey">
                        <p class="m-b-4">{{ time }}</p>
                        <!-- <p v-if="isOnePlace">{{ content.meet_place_1 }}에서 {{ meetType }} 제안</p>
                        <p v-else>{{ content.meet_place_1 }} 외 {{ places.length - 1 }}곳에서 {{ meetType }} 제안</p> -->

                        <p>
                            지역: {{ content.meet_place_1 }}{{ places.length > 1 ? ' or ' + content.meet_place_2 : ''
                            }}{{ places.length > 2 ? ' or ' + content.meet_place_3 : '' }}
                        </p>
                        <p>소개팅 방식: {{ meetType }}</p>
                    </div>
                </div>
                <div v-else class="grey-box m-t-8">
                    <ScheduleProgress :mode="gender === 1 ? 'a' : 'b'" :selected="2" />
                </div>
                <!-- 분기처리 추가 여자, 횟수제-->
                <div v-if="userRatePlans.onGoing && gender === 1" class="m-t-8 m-b-16">
                    <!-- <img class="m-r-4" src="@/assets/images/icons/info_pink.png" width="16px" height="16px" />

                    <div class="text" v-html="'약속 확정시 매칭권 1회가 사용됩니다'" /> -->
                </div>
            </div>
        </div>
        <BottomButton
            v-if="gender === 1"
            :disabled="disabled"
            @click="checkValidTicket"
            label="지역 선택 및 약속 확정"
            :nonFixed="true"
        />
    </div>
</template>

<script>
import ScheduleProgress from './ScheduleProgress'
import scheduleService from '@/services/schedule'

export default {
    name: 'ActionScheduleConfirm',
    props: ['message'],
    components: {
        ScheduleProgress,
    },
    computed: {
        me() {
            return this.$store.getters.me
        },
        content() {
            return this.$mustParse(this.message.content)
        },
        photoUrl() {
            return this.content.urls[0] || null
        },
        age() {
            return this.$options.filters.asAgeInActionMessage(this.content.birthday)
        },
        time() {
            const dateConfirmed = this.content.date_confirmed
            const date = this.$moment(dateConfirmed).format('YY/MM/DD')
            const day = this.$moment(dateConfirmed).format('dddd').toUpperCase()
            const time = this.$moment(dateConfirmed).format('A h시 mm분')

            return `${date} ${this.$translate(day)}, ${time}`
        },
        meetType() {
            const fixed = ['meal', 'coffee', 'wine', 'beer', 'izakaya']

            return fixed.includes(this.content.meet_type_confirmed)
                ? this.$translate(this.content.meet_type_confirmed.toUpperCase())
                : '커피 또는 식사'
        },
        disabled() {
            return this.content.status === 1
        },
        gender() {
            return this.$store.getters.me.gender
        },
        introduction() {
            return {
                title: this.gender === 1 ? '약속 내용을 확인하고 만날 지역을 선택해주세요.' : '잠시만 기다려주세요!',
                desc:
                    this.gender === 1
                        ? // ? '남성분이 일정을 선택하고, 만남 지역과 방식(커피 혹은 식사)을 입력해주셨어요.'
                          '남성분이 일정,지역,소개팅 방식을 선택해주셨어요.'
                        : '여성분이 일정을 확인하시면 자동으로 약속이 최종 확정됩니다!',
            }
        },
        userRatePlans() {
            return this.$store.getters.userRatePlans || {}
        },
        unlimitedRatePlan() {
            if (this.userRatePlans.onGoingTicketPlan.length === 0) return {}
            const plan = this.userRatePlans.onGoingTicketPlan.find(o => o.code.includes('unlimited'))
            if (plan) {
                return plan
            } else {
                return null
            }
        },
        validTickets() {
            return this.$store.getters.validTickets
        },
        mannerTickets() {
            return this.$store.getters.mannerTickets.filter(t => t.enabled)
        },
        PostpaidRatePlan() {
            if (
                this.userRatePlans.onGoingTicketPlan.find(o => o.ptype === 'rate_plan' && o.code.includes('unlimited'))
            ) {
                return this.$store.getters.products.all.find(
                    item =>
                        item.id ===
                        this.userRatePlans.onGoingTicketPlan.find(
                            o => o.ptype === 'rate_plan' && o.code.includes('unlimited')
                        ).product_id
                )
            }
            return false
        },
        selectPostpaidTicket() {
            if (!this.PostpaidRatePlan || !this.PostpaidRatePlan.code) return {}

            return this.me.tickets.find(item => item.enabled === true)
        },
        hasUnpaid() {
            return (this.me || {}).products.some(p => {
                return p.product_id === 62
            })
        },
        places() {
            if (this.content.meet_place_3) {
                return [this.content.meet_place_1, this.content.meet_place_2, this.content.meet_place_3]
            }
            if (this.content.meet_place_2) {
                return [this.content.meet_place_1, this.content.meet_place_2]
            }
            return [this.content.meet_place_1]
        },
        isOnePlace() {
            return this.places.length === 1
        },
    },
    methods: {
        async checkValidTicket() {
            // 매칭권 체크 2025.08.13
            if (
                !(this.userRatePlans.onGoingTicketPlan.length > 0) &&
                !(this.userRatePlans.onGoing.length > 0 && this.validTickets.length > 0) &&
                !(this.PostpaidRatePlan && this.PostpaidRatePlan.code.includes('unlimited')) &&
                !this.hasUnpaid &&
                !this.content.manner_like &&
                !this.content.is_michagam
            ) {
                this.$modal
                    .basic({
                        body: `보유한 매칭권이 없습니다. 매칭권을 구매해주세요.<br/>(만남을 갖기 위해서는 매칭권이 필요합니다.)`,
                        buttons: [
                            {
                                label: 'CANCEL',
                                class: 'btn-default',
                            },
                            {
                                label: 'BUY_DISCOUNT',
                                class: 'btn-primary',
                            },
                        ],
                    })
                    .then(idx => {
                        if (idx === 1) {
                            // console.log('134: ', this.selectPostpaidTicket)
                            // this.$store.commit('setSelectedProduct', this.selectPostpaidTicket)
                            this.$router.push({
                                name: 'PrePaymentPage',
                                // params: { categoryName: this.category.category },
                            })
                        }
                    })

                return
            } else {
                if (
                    this.PostpaidRatePlan &&
                    this.PostpaidRatePlan.plan_type === 'postpaid' &&
                    this.validTickets.length === 0 &&
                    !this.content.is_michagam
                ) {
                    // 후불제 product_id 조건 임시로 한건데 onGoing product 의 plan_type === 'postpaid' 인지 확인해야함
                    this.$modal
                        .basic({
                            body: `보유한 매칭권이 없습니다. 매칭권을 구매해주세요.<br/>(만남을 갖기 위해서는 매칭권이 필요합니다.)`,
                            buttons: [
                                {
                                    label: 'CANCEL',
                                    class: 'btn-default',
                                },
                                {
                                    label: 'BUY_DISCOUNT',
                                    class: 'btn-primary',
                                },
                            ],
                        })
                        .then(idx => {
                            if (idx === 1) {
                                console.log('134: ', this.selectPostpaidTicket)
                                this.$store.commit('setSelectedProduct', this.selectPostpaidTicket)
                                this.$router.push({
                                    name: 'TicketPaymentMethodsPage',
                                    // params: { categoryName: this.category.category },
                                })
                            }
                        })

                    return
                } else {
                    if (
                        (this.isAtype && this.content.manner_like === 'b_user') ||
                        (!this.isAtype && this.content.manner_like === 'a_user')
                    ) {
                        this.$modal
                            .basic({
                                title: '매너 수락',
                                body:
                                    '상대방이 ‘매너 수락’을 하여 매칭권을 사용하지 않고 약속을 진행할 수 있습니다. <br>참고로, 매너 수락을 위해 상대방이 추가 비용을 부담하였습니다. <br>진정성 있는 만남 부탁드립니다 :)',
                                buttons: [
                                    {
                                        label: 'CANCEL',
                                        class: 'btn-default',
                                    },
                                    {
                                        label: 'CONFIRM',
                                        class: 'btn-primary',
                                    },
                                ],
                            })
                            .then(idx => {
                                if (idx === 1) {
                                    this.onClickSelect()
                                }
                            })
                    } else if (
                        (this.isAtype && this.content.manner_like === 'a_user') ||
                        (!this.isAtype && this.content.manner_like === 'b_user')
                    ) {
                        if (this.mannerTickets.length > 0) {
                            console.log('123', this.$store.getters.products)
                            this.$modal
                                .basic({
                                    title: '매너 수락',
                                    body: '이미 보유한 매너수락권을 사용해 매칭을 진행합니다.',
                                    buttons: [
                                        {
                                            label: 'CANCEL',
                                            class: 'btn-default',
                                        },
                                        {
                                            label: 'CONFIRM',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                                .then(idx => {
                                    if (idx === 1) {
                                        if (
                                            !this.PostpaidRatePlan &&
                                            this.PostpaidRatePlan.code !== 'unlimited_female' &&
                                            this.PostpaidRatePlan.code !== 'unlimited_male' &&
                                            this.validTickets.length === 0 &&
                                            !this.content.is_michagam
                                        ) {
                                            this.$modal
                                                .basic({
                                                    body: `보유한 매칭권이 없습니다. 매칭권을 구매해주세요.<br/>(만남을 갖기 위해서는 매칭권이 필요합니다.)`,
                                                    buttons: [
                                                        {
                                                            label: 'CANCEL',
                                                            class: 'btn-default',
                                                        },
                                                        {
                                                            label: 'BUY_DISCOUNT',
                                                            class: 'btn-primary',
                                                        },
                                                    ],
                                                })
                                                .then(idx => {
                                                    if (idx === 1) {
                                                        this.$router.push({
                                                            name: 'PrePaymentPage',
                                                        })
                                                    }
                                                })
                                        } else {
                                            this.onClickSelect()
                                        }
                                    }
                                })
                        } else {
                            if (
                                !this.PostpaidRatePlan &&
                                this.PostpaidRatePlan.code !== 'unlimited_female' &&
                                this.PostpaidRatePlan.code !== 'unlimited_male' &&
                                this.validTickets.length === 0 &&
                                !this.content.is_michagam
                            ) {
                                // console.log('AAA')
                                this.$modal
                                    .basic({
                                        body: `보유한 매칭권이 없습니다. 매칭권을 구매해주세요.<br/>(만남을 갖기 위해서는 매칭권이 필요합니다.)`,
                                        buttons: [
                                            {
                                                label: 'CANCEL',
                                                class: 'btn-default',
                                            },
                                            {
                                                label: 'BUY_DISCOUNT',
                                                class: 'btn-primary',
                                            },
                                        ],
                                    })
                                    .then(idx => {
                                        if (idx === 1) {
                                            this.$router.push({
                                                name: 'PrePaymentPage',
                                            })
                                        }
                                    })
                                return
                            }
                            this.$modal
                                .basic({
                                    title: '매너 수락',
                                    body:
                                        '매너 수락 비용 3만원을 결제해주세요. 매너 수락 비용 결제 이후에 매칭권을 사용합니다.',
                                    buttons: [
                                        {
                                            label: 'CANCEL',
                                            class: 'btn-default',
                                        },
                                        {
                                            label: '결제하기',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                                .then(idx => {
                                    if (idx === 1) {
                                        const selectMannerTicket = this.$store.getters.products.ticket_plan.find(
                                            item => item.code === `ticket_manner_like`
                                        )
                                        this.$store.commit('setSelectedProduct', selectMannerTicket)
                                        this.$store.commit('setSelectedPlan', selectMannerTicket)
                                        this.$router.push({
                                            name: 'PaymentMethodsPage',
                                            // params: { categoryName: this.category.category },
                                        })
                                    }
                                })
                        }
                    } else {
                        // this.onClickSelect()
                        // console.log('this.userRatePlans', this.userRatePlans)
                        // console.log('this.unlimitedRatePlan', this.unlimitedRatePlan)
                        if (this.unlimitedRatePlan && this.unlimitedRatePlan.ptype === 'rate_plan') {
                            this.$modal
                                .basic({
                                    body: `기간권을 사용하여, 매칭권 소모 없이 약속 잡기를 시작합니다.`,
                                    buttons: [
                                        {
                                            label: 'CANCEL',
                                            class: 'btn-default',
                                        },
                                        {
                                            label: 'CONFIRM',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                                .then(idx => {
                                    if (idx === 1) {
                                        this.onClickSelect()
                                    }
                                })
                        } else if (this.validTickets.length > 0) {
                            this.$modal
                                .basic({
                                    body: `매칭권 1장이 소모됩니다. (현재 보유한 매칭권: ${this.validTickets.length}장)`,
                                    buttons: [
                                        {
                                            label: 'CANCEL',
                                            class: 'btn-default',
                                        },
                                        {
                                            label: 'CONFIRM',
                                            class: 'btn-primary',
                                        },
                                    ],
                                })
                                .then(idx => {
                                    if (idx === 1) {
                                        this.onClickSelect()
                                    }
                                })
                        } else {
                            this.onClickSelect()
                        }
                    }
                }
            }
            if (this.content.is_michagam) {
                this.onClickSelect()
            }
        },
        async onClickSelect() {
            const res = await this.$modal.custom({
                component: 'ModalSelectRegion',
                options: { places: this.places, content: this.content },
            })

            if (res) {
                this.onClickConfirm(res)
            }
        },
        async onClickConfirm(res) {
            // if (this.userRatePlans.onGoing || this.hasUnpaid) {
            const payload = { product_id: 1 }
            payload[`${this.$store.getters.me.gender === 1 ? 'a' : 'b'}_message_id`] = this.message.id
            payload.meet_place = res

            try {
                this.$loading(true)
                const { res } = await scheduleService.createSchedule(this.content.schedule_id, payload)
                if (['confirmed_both'].includes(res)) {
                    this.$store.dispatch('loadChat', { chatId: this.message.chat_id, force: true })
                    this.$store.dispatch('loadMe')
                } else {
                    this.$toast.error(res)
                }
                this.$loading(false)
            } catch (e) {
                this.$loading(false)
                this.$toast.error(e.data.msg)
            }
            // } else {
            //     this.$modal.basic({
            //         title: '프로그램 이용이 만료되었습니다',
            //         body: '약속을 진행하려면 프로그램을 구매해주세요',
            //         buttons: [
            //             {
            //                 label: 'CONFIRM',
            //                 class: 'btn-primary',
            //             },
            //         ],
            //     })
            // }

            this.$stackRouter.pop()

            // this.$stackRouter.push({
            //     name: 'SchedulePayPage',
            //     props: {
            //         userInfo: {
            //             photoUrl: this.photoUrl,
            //             age: this.age,
            //             region: this.content.region,
            //             job: this.content.job,
            //             message: this.message,
            //             schedule_id: this.content.schedule_id,
            //             date_confirmed: this.content.date_confirmed,
            //             meet_place: this.content.meet_place,
            //             meet_type_confirmed: this.content.meet_type_confirmed,
            //         },
            //     },
            // })
        },
    },
}
</script>
<style scoped lang="scss">
.desc {
    font-size: 14px;
}
.desc-detail {
    margin: 0 0 8px 0;
    color: #f64f56;
    font-size: 10px;
    line-height: 17px;
    font-style: italic;
}

.info {
    background: rgba(255, 61, 107, 0.07);
    border-radius: 8px;
    padding: 4px 8px;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #111111;
    display: flex;
    align-items: center;
}
</style>
